import axios from "axios";
import { Alert } from "react-native";

import { API_URL, STATIC_FILES_URL } from "@/config/enviroment";
import { store } from "@/store";
import { LOGOUT } from "@/store/ducks/auth";

import { retrieveApiToken } from "./token";

export const api = axios.create({
  baseURL: API_URL,
});

function backToLogin() {
  Alert.alert("Não foi possível iniciar sua sessão", "Por favor faça Login novamente!", [
    {
      text: "OK",
      onPress: () => {
        store.dispatch(LOGOUT());
      },
    },
  ]);
}

api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      backToLogin();
    }
    return Promise.reject(error);
  }
);

api.interceptors.request.use(async (config) => {
  const token = await retrieveApiToken();
  if (token) {
    config.headers["Authorization"] = token;
  }
  return config;
});

export const image_path_stores = STATIC_FILES_URL + "/images/estabelecimentos";
export const image_path_store_types = STATIC_FILES_URL + "/images/estabelecimentos/tipos";
export const image_path_products = STATIC_FILES_URL + "/images/produtos";
export const image_path_products_card = STATIC_FILES_URL + "/images/130x130";
export const image_path_categories = STATIC_FILES_URL + "/images/estabelecimentos/corredores";
export const image_path_promotions = STATIC_FILES_URL + "/images/estabelecimentos/promocoes";
export const image_path_highlights = STATIC_FILES_URL + "/images/estabelecimentos/destaques";
export const image_path_credit_cards = STATIC_FILES_URL + "/images/cartoes";
